import React, { useEffect, useState } from 'react';
import BaseTable from '@/components/base-table';
import { Tooltip } from 'antd';
import { buildKey, getLocalStorageValue } from '@/common/utils';
import configs from '@/config';
const buildRowData = (data) =>
  data.map((el, idz) => ({
    ...el,
    no: idz + 1,
    key: buildKey('temp-request', el.responseId ? el.responseId : Math.random()),
  }));
const POS_CLIENT_REQUESTS = 'POS_CLIENT_REQUESTS';

const TemporaryRequests = () => {
  const [data, setData] = useState([]);

  /**
   * Get data from localStorage
   */
  const getDataFunc = () => {
    // const queryParams = { ...queryData, ...params };
    let result = [];
    try {
      result = getLocalStorageValue(POS_CLIENT_REQUESTS);
      result = JSON.parse(result);
      if (result.length) result.reverse();
    } catch (err) {
      // console.log(err);
    }
    return setData(buildRowData(result));
  };

  useEffect(() => {
    getDataFunc();
  }, []);

  /**
   * clear value for function search
   */
  const clearSearch = () => {
    getDataFunc();
  };

  /**
   * Search category by name
   * @param search
   */
  const onSearch = (search = '') => {
    const searchVal = `${search}`;
    if (!searchVal) return clearSearch();
    const result = data.filter(
      ({ url, method, status, responseId }) =>
        (url && url.indexOf(searchVal) !== -1) ||
        (method && method.indexOf(searchVal) !== -1) ||
        (responseId && responseId.indexOf(searchVal) !== -1) ||
        (status && `${status}` === searchVal),
    );
    return setData(buildRowData(result));
  };

  const getTelescopeUrl = (tag, id, host) =>
    encodeURI(
      (host?.includes('irs')
        ? configs.irsUrl + '/telescope'
        : configs.baseUrl.replace('/api', '/telescope')) +
        '/requests?tag=' +
        tag +
        ':' +
        id,
    );

  const columns = [
    {
      title: 'Date & Time',
      dataIndex: 'time',
      align: 'left',
    },
    {
      title: 'Host',
      dataIndex: 'host',
      align: 'center',
      render: (value) => <Tooltip title={value}>{value?.includes('irs') ? 'IRS' : 'POS'}</Tooltip>,
    },
    {
      title: 'Method',
      dataIndex: 'method',
      align: 'center',
      render: (value) => value?.toUpperCase(),
    },
    {
      title: 'URL',
      dataIndex: 'url',
      align: 'left',
      render: (value, record) => (
        <Tooltip title={record?.fullUrl || ''}>
          {record.fullUrl?.replace(record?.host, '') || value}
        </Tooltip>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      render: (value) => (
        <span className={value >= 500 ? 'color-danger' : value >= 400 ? 'color-warning' : ' }'}>
          {value}
        </span>
      ),
    },
    {
      title: 'Request ID',
      dataIndex: 'requestId',
      align: 'left',
      render: (value, record) => (
        <a
          target="_blank"
          href={getTelescopeUrl('request', value, record.host)}
          className="color-blue-9"
        >
          {value}
        </a>
      ),
    },
    {
      title: 'Response ID',
      dataIndex: 'responseId',
      align: 'left',
      render: (value, record) => (
        <a
          target="_blank"
          href={getTelescopeUrl('response', value, record.host)}
          className="color-blue-9"
        >
          {value}
        </a>
      ),
    },
  ];

  return (
    <BaseTable
      onSearch={onSearch}
      rowKey="key"
      columns={columns}
      data={[...data]}
      isLoading={false}
      isPagination={false}
      isExpandProp={false}
      isFilter={false}
    />
  );
};

export default TemporaryRequests;
